import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Phone, Mail, Globe, Lock } from 'lucide-react';
import { toast, Toaster } from 'sonner';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      toast.success('Request submitted successfully. We will contact you shortly.', {
        style: {
          background: '#111827',
          color: '#fff',
          border: '1px solid #C9A84C'
        }
      });
      (e.target as HTMLFormElement).reset();
    }, 1000);
  };
  return <section id="contact" className="py-24 bg-navy relative border-b border-white/5" data-id="element-74">
      <Toaster position="bottom-right" data-id="element-75" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-77">
          {/* Left Column: Info */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col justify-center" data-id="element-78">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6 uppercase" data-id="element-79">
              Ready to Move <br data-id="element-80" />
              <span className="text-gold" data-id="element-81">Critical Cargo?</span>
            </h2>

            <div className="space-y-4 mb-10" data-id="element-82">
              {['Free Quote', '24/7 Dispatch Available', 'Fully Insured', 'Nationwide Coverage'].map((item, idx) => <div key={idx} className="flex items-center" data-id="element-83">
                  <CheckCircle2 className="w-6 h-6 text-gold mr-3" data-id="element-84" />
                  <span className="text-lg text-slate-300 font-medium" data-id="element-85">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="bg-navy-light rounded-2xl p-8 border border-white/5 space-y-6" data-id="element-86">
              <a href="tel:+17862620064" className="flex items-center group" data-id="element-87">
                <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center mr-4 border border-white/10 group-hover:border-gold/50 transition-colors" data-id="element-88">
                  <Phone className="w-5 h-5 text-gold" data-id="element-89" />
                </div>
                <div data-id="element-90">
                  <span className="block text-sm text-slate-400 uppercase tracking-wider mb-1" data-id="element-91">
                    24/7 Phone
                  </span>
                  <span className="text-white font-heading text-xl tracking-wide group-hover:text-gold transition-colors" data-id="element-92">
                    +1 786-262-0064
                  </span>
                </div>
              </a>

              <a href="mailto:dispatch@jetforceaviation.com" className="flex items-center group" data-id="element-93">
                <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center mr-4 border border-white/10 group-hover:border-gold/50 transition-colors" data-id="element-94">
                  <Mail className="w-5 h-5 text-gold" data-id="element-95" />
                </div>
                <div data-id="element-96">
                  <span className="block text-sm text-slate-400 uppercase tracking-wider mb-1" data-id="element-97">
                    Dispatch Email
                  </span>
                  <span className="text-white text-base group-hover:text-gold transition-colors break-all" data-id="element-98">
                    dispatch@jetforceaviation.com
                  </span>
                </div>
              </a>

              <a href="mailto:operations@jetforceaviation.com" className="flex items-center group" data-id="element-99">
                <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center mr-4 border border-white/10 group-hover:border-gold/50 transition-colors" data-id="element-100">
                  <Mail className="w-5 h-5 text-gold" data-id="element-101" />
                </div>
                <div data-id="element-102">
                  <span className="block text-sm text-slate-400 uppercase tracking-wider mb-1" data-id="element-103">
                    Operations Email
                  </span>
                  <span className="text-white text-base group-hover:text-gold transition-colors break-all" data-id="element-104">
                    operations@jetforceaviation.com
                  </span>
                </div>
              </a>

              <a href="https://jetforceaviation.com" target="_blank" rel="noopener noreferrer" className="flex items-center group" data-id="element-105">
                <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center mr-4 border border-white/10 group-hover:border-gold/50 transition-colors" data-id="element-106">
                  <Globe className="w-5 h-5 text-gold" data-id="element-107" />
                </div>
                <div data-id="element-108">
                  <span className="block text-sm text-slate-400 uppercase tracking-wider mb-1" data-id="element-109">
                    Website
                  </span>
                  <span className="text-white text-base group-hover:text-gold transition-colors" data-id="element-110">
                    jetforceaviation.com
                  </span>
                </div>
              </a>
            </div>
          </motion.div>

          {/* Right Column: Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-111">
            <div className="bg-navy-light rounded-3xl p-8 md:p-10 border border-white/10 shadow-2xl relative overflow-hidden" data-id="element-112">
              <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-[80px] -mr-20 -mt-20 pointer-events-none" data-id="element-113"></div>

              <h3 className="text-2xl font-heading font-bold text-white mb-6 uppercase" data-id="element-114">
                Request a Quote
              </h3>

              <form onSubmit={handleSubmit} className="space-y-5 relative z-10" data-id="element-115">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-116">
                  <div data-id="element-117">
                    <label htmlFor="name" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-118">
                      Full Name *
                    </label>
                    <input required type="text" id="name" className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors" placeholder="John Doe" data-id="element-119" />
                  </div>
                  <div data-id="element-120">
                    <label htmlFor="company" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-121">
                      Company Name
                    </label>
                    <input type="text" id="company" className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors" placeholder="Aviation Co." data-id="element-122" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-123">
                  <div data-id="element-124">
                    <label htmlFor="phone" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-125">
                      Phone Number *
                    </label>
                    <input required type="tel" id="phone" className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors" placeholder="+1 (555) 000-0000" data-id="element-126" />
                  </div>
                  <div data-id="element-127">
                    <label htmlFor="email" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-128">
                      Email Address *
                    </label>
                    <input required type="email" id="email" className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors" placeholder="john@example.com" data-id="element-129" />
                  </div>
                </div>

                <div data-id="element-130">
                  <label htmlFor="service" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-131">
                    Service Type *
                  </label>
                  <select required id="service" className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors appearance-none" data-id="element-132">
                    <option value="" data-id="element-133">Select a service...</option>
                    <option value="transport" data-id="element-134">Aviation Transport</option>
                    <option value="line_maintenance" data-id="element-135">
                      A&P Line Maintenance
                    </option>
                    <option value="100_hour" data-id="element-136">100 Hour Inspection</option>
                    <option value="interior_clean" data-id="element-137">
                      Aircraft Interior Cleaning
                    </option>
                    <option value="exterior_wash" data-id="element-138">
                      Aircraft Exterior Dry Wash
                    </option>
                    <option value="aog" data-id="element-139">AOG Support</option>
                    <option value="custom" data-id="element-140">Custom Quote</option>
                  </select>
                </div>

                <div data-id="element-141">
                  <label htmlFor="description" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-142">
                    Description of Need *
                  </label>
                  <textarea required id="description" rows={4} className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors resize-none" placeholder="Please provide details about your cargo, aircraft, location, and timeline..." data-id="element-143"></textarea>
                </div>

                <div data-id="element-144">
                  <label className="block text-sm font-medium text-slate-400 mb-2" data-id="element-145">
                    Preferred Contact Method
                  </label>
                  <div className="flex gap-4" data-id="element-146">
                    <label className="flex items-center cursor-pointer" data-id="element-147">
                      <input type="radio" name="contact_method" value="phone" className="w-4 h-4 text-gold bg-navy border-white/10 focus:ring-gold focus:ring-offset-navy" defaultChecked data-id="element-148" />
                      <span className="ml-2 text-sm text-slate-300" data-id="element-149">Phone</span>
                    </label>
                    <label className="flex items-center cursor-pointer" data-id="element-150">
                      <input type="radio" name="contact_method" value="email" className="w-4 h-4 text-gold bg-navy border-white/10 focus:ring-gold focus:ring-offset-navy" data-id="element-151" />
                      <span className="ml-2 text-sm text-slate-300" data-id="element-152">Email</span>
                    </label>
                    <label className="flex items-center cursor-pointer" data-id="element-153">
                      <input type="radio" name="contact_method" value="whatsapp" className="w-4 h-4 text-gold bg-navy border-white/10 focus:ring-gold focus:ring-offset-navy" data-id="element-154" />
                      <span className="ml-2 text-sm text-slate-300" data-id="element-155">
                        WhatsApp
                      </span>
                    </label>
                  </div>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full bg-gold hover:bg-gold-light text-navy font-bold py-4 rounded-xl transition-all shadow-gold-glow hover:shadow-gold-glow-lg mt-4 flex items-center justify-center text-lg disabled:opacity-70" data-id="element-156">
                  {isSubmitting ? 'Submitting...' : 'Submit Request →'}
                </button>

                <div className="flex items-center justify-center mt-4 text-slate-500 text-xs" data-id="element-157">
                  <Lock className="w-3 h-3 mr-1.5" data-id="element-158" />
                  Your information is private and never shared.
                </div>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}